import CorporateSignup from "../pages/CorporateSignup";
import CorporateSignupSuccess from "../pages/CorporateSignupSuccess";
import InviteYourColleagues from "../pages/InviteYourColleagues"
import AllCountryAutomatedSignup from "../pages/AllCountryAutomatedSignup";

const ROUTES = [
    {
        path: '/corporate-signup',
        pageElement: (pageDetails) => {
           return <CorporateSignup  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/:pos/corporate-signup',
        pageElement: (pageDetails) => {
           return <CorporateSignup  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/corporate-signup-success',
        pageElement: () => {
            return <CorporateSignupSuccess />
         },
        exact: true
    },
    {
        path: '/:pos/corporate-signup-success',
        pageElement: () => {
            return <CorporateSignupSuccess />
         },
        exact: true,
        
    },
    {
        path: '/corporate-signup/invite-your-colleagues',
        pageElement: () => {
            return <InviteYourColleagues />
         },
        exact: true
    },
    {
        path: '/:pos/corporate-signup/invite-your-colleagues',
        pageElement: () => {
            return <InviteYourColleagues />
         },
        exact: true,
        
    },
    {
        path: '/all-country-corporate-signup',
        pageElement: (pageDetails) => {
           return <AllCountryAutomatedSignup  pageDetails = {pageDetails} />
        },
        
    }
    
    
];


export default ROUTES;